<template>
  <div>
    <TableList
      ref="table"
      :cols="cols"
      :list="list"
      :height="tableHeight"
      :rowHeight="100"
    >
      <template slot="publishStatusSlot" slot-scope="{ row }">
        <el-button @click="showProgress(row)" type="link" v-if="row.status == 0">{{ formatStatus(row) }}</el-button>
        <span v-else>{{ formatStatus(row) }}</span>
      </template>
      <template slot="opcolsSlot" slot-scope="{ row }">
        <el-button
          type="link"
          @click="jumpDetail(row)"
          >查看明细</el-button
        >
      </template>
    </TableList>
  </div>
</template>

<script>
import TableList from "@/components/TableList.vue";
import prod_center_dictionary from "@/components/prod/center/dictionary.js";
import tableMixins from '@mixins/table-mixins';
import { mapActions, mapMutations, mapGetters} from "vuex";

export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
    mode: {
      type: String,
      default: "supplier",
    },
  },
  mixins: [new tableMixins(176,{ refName:'search' })],
  components: {
    TableList,
  },
  data() {
    return {
      cols: [
        { prop: "startTime", attrs: { label: "更新时间" } },
        { prop: "channel", attrs: { label: "途径" } },
        { prop: "source", attrs: { label: "店铺" }},
        { prop: "publishStatus", attrs: { label: "状态" },slot: true  },
        { prop: "staffName", attrs: { label: "操作人" } },
        { prop: "total", attrs: { label: "更新总数" } },
        { prop: "successTotal", attrs: { label: "更新成功数" } },
        { prop: "failureTotal", attrs: { label: "更新失败数" } },
        { prop: "opcols", attrs: { label: "操作" }, slot: true }
      ],
    };
  },
  computed: {
    ...mapGetters(['routerPrefix', 'subCodeMap']),
    update_status_map() {
      const { UPDATE_STATUS_MAP }  = prod_center_dictionary;
      return UPDATE_STATUS_MAP;
    }
  },
  methods: {
    ...mapActions(['publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    formatStatus (rowData) {
      const { channel, status } = rowData;
      const subCode = this.subCodeMap[channel];
      const { UPDATE_STATUS_MAP, OFF_SALE_STATUS_MAP }  = prod_center_dictionary;
      if (subCode === 30) {
        return OFF_SALE_STATUS_MAP[status]
      }
      return UPDATE_STATUS_MAP[status]
    },
    jumpDetail(rowData) {
       this.$router.push({
          name: `${this.routerPrefix}prod_log`,
          query:{
            id: rowData.id
          }
      })
    },
    showProgress(rowData) {
        this.$emit('show-progress',rowData)
        // this.setCurrentPage(`${this.routerPrefix}updateLog`);
        // this.publishSpeed({publishType, resultVisible: true})
      }
  },
};
</script>

<style lang="scss" scoped>

</style>
